// extracted by mini-css-extract-plugin
export default {"mediaLaptop":"1500px","mediaSmallScreen":"2560px","mainTableMaxHeight":"910px","mediaMobile":"480px"};